module.exports = __webpack_public_path__ + "static/npckc2-b412af609db183f44e514a7c7209bc60.webp";